import React, { useRef } from "react";
import uploadUnfilled from '../../../../assets/uploadUnfilled.svg';
import { useAppStore } from "../../../../GlobalStore/GlobalStore.ts";
import {UploadMenu} from "./UploadMenu/UploadMenu.tsx";

interface UploadProps {}

const Upload: React.FC<UploadProps> = () => {
    const uploadButtonRef = useRef<HTMLButtonElement>(null);
    const dynamicStateObj = useAppStore((state: any) => state.dynamicStateObj);
    const { isUploadOpen } = dynamicStateObj;
    const setDynamicStateObj = useAppStore((state: any) => state.setDynamicStateObj);
    const uploadFilledSvg = "https://wfclardozsxtrutoorim.supabase.co/storage/v1/object/public/images/uploadFilled.svg";
    const settingsObj = useAppStore((state: any) => state.settingsObj);
    const { theme } = settingsObj;
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment } = environmentObj;

    const handleUpload = (event: React.MouseEvent) => {
        event.stopPropagation();
        setDynamicStateObj({ isUploadOpen: !isUploadOpen });
    };

    const getButtonDimensions = () => {
        if (environment === "vscode") return "h-7 w-7";
        else return "h-8 w-8";
    };
    const buttonDimensions = getButtonDimensions();

    return (
        <>
            <UploadMenu buttonRef={uploadButtonRef} />
            <button ref={uploadButtonRef} onClick={handleUpload}>
                <img
                    src={`${theme === "dark" ? uploadFilledSvg : uploadUnfilled}`}
                    alt={'Upload'}
                    className={`${buttonDimensions} cursor-pointer transition-all duration-200 ${isUploadOpen ? 'rotate-45' : ''}`}
                />
            </button>
        </>
    );
};

export default Upload;